<template>
  <section class="lesson-section">
    <h2 class="lesson-section-title">
      {{ data.title }}
      <TextToSpeech :text="data.title" />
    </h2>
    <component v-if="componentToLoad" :is="componentToLoad" :data="data" />
    <ErrorMessage v-else>
      {{
        $t('components.lesson.unknown-lesson-section-type-error', {
          type: data.type,
        })
      }}
    </ErrorMessage>
  </section>
</template>

<script>
import ErrorMessage from '../ui/ErrorMessage'
import LessonSectionGeogebra from './lessonsections/LessonSectionGeogebra'
import LessonSectionHtml from './lessonsections/LessonSectionHtml'
import LessonSectionPicture from './lessonsections/LessonSectionPicture'
import LessonSectionQuestion from './lessonsections/LessonSectionQuestion'
import LessonSectionVideo from './lessonsections/LessonSectionVideo'
import TextToSpeech from '../accessibility/TextToSpeech'

import { LessonSectionType } from '../../enums'

export default {
  name: 'LessonSection',
  components: { ErrorMessage, TextToSpeech },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    componentToLoad() {
      switch (this.data.type) {
        case LessonSectionType.GEOGEBRA:
          return LessonSectionGeogebra
        case LessonSectionType.HTML:
          return LessonSectionHtml
        case LessonSectionType.PICTURE:
          return LessonSectionPicture
        case LessonSectionType.QUESTION:
          return LessonSectionQuestion
        case LessonSectionType.VIDEO:
          return LessonSectionVideo
        default:
          return null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-section {
  position: relative;
  font-size: $copyFontSize;
  line-height: 1.4em;
  padding: 1em 2em;

  // Override global Fessor style
  margin: 0;
  max-width: none;
}

.lesson-section-title {
  font-size: 1.7em;
  margin-bottom: 1em;
  line-height: 1.4em;
}

.lessonSection {
  .geometryFileContainer {
    text-align: center;
  }

  > .question {
    font-size: 1em;
  }
}
</style>
